module.exports = __webpack_public_path__ + "img/logo.7063b799.png";